import React, { useEffect, useRef, useState } from 'react';

// Contenitore delle azioni dell'header. Da telefono in giu' (< 48rem) le
// azioni non stanno in riga accanto al titolo: prima erano semplicemente
// `.desktop-only` (display:none sotto i 768px), quindi il banditore da
// telefono non poteva ne' aprire le impostazioni ne' importare le rose.
// Qui le stesse azioni finiscono in un pannello a comparsa; da 48rem in su
// il CSS le rimette in riga e nasconde il bottone.
export default function AppMenu({ children }) {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;

        const onKeyDown = (event) => {
            if (event.key === 'Escape') setOpen(false);
        };
        const onClickOutside = (event) => {
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('keydown', onKeyDown);
        document.addEventListener('mousedown', onClickOutside);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
            document.removeEventListener('mousedown', onClickOutside);
        };
    }, [open]);

    return (
        <div className="app-menu" ref={rootRef}>
            <button
                type="button"
                className="app-menu-toggle"
                aria-haspopup="menu"
                aria-expanded={open}
                aria-label="Apri il menu azioni"
                onClick={() => setOpen((current) => !current)}
            >
                &#8943;
            </button>
            {open && (
                <div className="app-menu-panel" role="menu" onClick={() => setOpen(false)}>
                    {children}
                </div>
            )}
        </div>
    );
}
